<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="TERCEROS" key="1">
          <g-master name="third"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="90%"
                    :useMultipart="true"
                    :beforeSend="master.beforeSend"
                    @action="masterAction"
          >
            <span slot="estadoRenderer" slot-scope="{text}">
              <a-tag :color="text==='INACTIVO' ? 'red' : 'blue'">{{text}}</a-tag>
            </span>
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Tipo de Tercero')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_type_third', { rules: [{ required: false}] }]"
                              :params="id_h_type_third"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Documento">
                    <a-input
                      v-decorator="['document_number', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Tipo de documento')"
                              :formItemConfig="fiOptions"
                              :decorator="['document_type', { rules: [{ required: false}] }]"
                              :params="document_type">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre">
                    <a-input
                      v-decorator="['name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('País')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_country', { rules: [{ required: false }] }]"
                              :customSlots="['suffixIcon']"
                              :selectedObj.sync="dropdown.country"
                              :params="id_h_country"
                              ref="id_h_country">
                    <template slot="suffixIcon">
                      <img style="max-width: 20px"
                           :src="flags[dropdown.country.equivalency]"
                           alt=""
                           v-if="dropdown.country && dropdown.equivalency">
                    </template>
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Departamento')"
                              :formItemConfig="fiOptions"
                              :selectedObj.sync="dropdown.depart"
                              :decorator="['id_h_department', { rules: [{ required: false}] }]"
                              :params="departParams">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Ciudad')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_city', { rules: [{ required: false}] }]"
                              :params="cityParams">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Dirección')">
                    <a-input
                      v-decorator="['address', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Telefono')">
                    <a-input
                      v-decorator="['phone', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Telefono 2')">
                    <a-input
                      v-decorator="['phone_1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                <a-form-item label="Correo Electrónico" v-bind="fiOptions">
                  <a-input
                    placeholder="Correo electrónico"
                    v-decorator="['mail', { rules: [{ required: false, message: 'Valor requerido' },
                                                                                                   { pattern: modalPattern, message: 'Debe ser un correo válido.' }
                                                                                                    ]}]">
                  </a-input>
                </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['status', { rules: [{ required: false }] }]"
                              :params="code_status_sn">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="ciuu"
                              style="width: 100%"
                              :label="$t('Código de la actividad económica')"
                              :formItemConfig="fiOptions"
                              :decorator="['cod_ciuu', { rules: [{ required: false }] }]"
                              >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Comentario" v-bind="fiOptions">
                    <a-textarea autoSize
                                v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Equivalencia')">
                    <a-input
                      v-decorator="['equivalency', { rules: [{ required: false, message: 'valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="bank"
                              style="width: 100%"
                              :label="$t('Banco')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_bank', { rules: [{ required: false }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Tipo de cuenta')"
                              :formItemConfig="fiOptions"
                              :decorator="['bank_type', { rules: [{ required: false }] }]"
                              :params="tipo_cuenta">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cuenta Bancaria">
                    <a-input
                      v-decorator="['bank_account', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre Contacto">
                    <a-input
                      v-decorator="['contact_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Subir Documento')">
                    <a-upload
                      name="profile_file"
                      :before-upload="beforeUpload"
                      :fileList="master.uploads.profileFile"
                      :remove="() => { master.uploads.profileFile = [] }">
                      <a-button style="width: 100%"><a-icon type="upload" />Documento</a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        flags: FLAGS,
        loadingBtns: {},
        code_status_sn: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        id_h_country: {
          h_lookup_type: 'PAISES'
        },
        id_h_type_third: {
          h_lookup_type: 'TIPO_TERCERO'
        },
        document_type: {
          h_lookup_type: 'TIPO_DOCUMENTO',
          use_code: true
        },
        tipo_cuenta: {
          h_lookup_type: 'TIPO_CUENTA',
          use_code: true
        },
        dropdown: {
          country: {},
          city: {},
          depart: {}
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Pais', column: 'h_country'},
            {label: 'Departamento', column: 'h_department'},
            {label: 'Ciudad', column: 'h_city'},
            {label: 'Teléfono 2', column: 'phone_1'},
            {label: 'Código de la actividad económica', column: 'cod_ciuu'},
            {label: 'Banco', column: 'd_bank'},
            {label: 'Tipo de cuenta', column: 'bank_type'},
            {label: 'Cuenta bancaria', column: 'bank_account'},
            {label: 'Nombre de contacto', column: 'contact_name'},
            {label: 'Equivalencia', column: 'equivalency'},
            {label: 'Nombre asociado', column: 'name_associated'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'third',
          tableSetup: {
            customSlots: ['expandedRowRender', 'estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            columns: [
              {title: 'Tipo tercero', dataIndex: 'h_type_third', sorter: true},
              {title: 'Tipo documento', dataIndex: 'document_type', sorter: true},
              {title: 'Documento', dataIndex: 'document_number', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Direccion', dataIndex: 'address', sorter: true},
              {title: 'Telefono', dataIndex: 'phone', sorter: true},
              {title: 'Correo', dataIndex: 'mail', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'address'},
            {name: 'cod_ciuu'},
            {name: 'comments'},
            {name: 'document_number'},
            {name: 'document_type'},
            {name: 'equivalency'},
            {name: 'fax'},
            {name: 'id'},
            {name: 'id_h_city'},
            {name: 'id_h_country'},
            {name: 'id_h_department'},
            {name: 'id_h_type_third'},
            {name: 'mail'},
            {name: 'name'},
            {name: 'name_associated'},
            {name: 'phone'},
            {name: 'phone_1'},
            {name: 'status'},
            {name: 'zone_cod'},
            {name: 'id_bank'},
            {name: 'bank_type'},
            {name: 'bank_account'},
            {name: 'contact_name'}
          ],
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            return data
          }
        },
        modalPattern: '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'
      }
    },
    methods: {
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id] = record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('third/download', {
          id: record.id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const isJpgOrPng = file.type === 'application/pdf'
        if (!isJpgOrPng) {
          this.$message.error('Solo se pemiten documentos pdf')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      }
    },
    computed: {
      cityParams () {
        return {h_lookup_type: 'CIUDADES', id_h_lookup_father: this.dropdown.depart.value}
      },
      departParams () {
        return {h_lookup_type: 'DEPARTAMENTOS', id_h_lookup_father: this.dropdown.country.value}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Third/Third.vue